import { render, staticRenderFns } from "./Feature7.vue?vue&type=template&id=1e538c3e&"
import script from "./Feature7.vue?vue&type=script&lang=js&"
export * from "./Feature7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports